import React from "react";
import styles from "./SyncStatusKey.module.css";
import StatusIcon from "../StatusIcon";
import Card from "shared/Card";

/**
 * View component. Key to explain the sync status icons.
 */

export function SyncStatusKey() {
  return (
    <Card className={styles.cardContainer}>
      <h5 className={styles.title}>SYNC STATUS</h5>

      <div className={styles.hr} />
      <div className={styles.contentContainer}>
        <div className={styles.yesDiv}>
          <StatusIcon status="yes" className={styles.status} />
          <p className={styles.text}>The user is in this group correctly.</p>
        </div>
        <div className={styles.yesDiv2}>
          <StatusIcon status="no" className={styles.status} />
          <p className={styles.text}>
            User should be in group, but is not. Run sync to have system put
            them back in.
          </p>
        </div>
        <div className={styles.yesDiv3}>
          <StatusIcon status="important" className={styles.status} />
          <p className={styles.text3}>The group is not part of the sync.</p>
        </div>
      </div>
    </Card>
  );
}
